const formComponentTranslations = {
  ActivityLevel: {
    level: "Select your activity level",
    sedentary: "Sedentary",
    light: "Light",
    moderate: "Moderate",
    active: "Active",
    veryActive: "Very Active",
    trainingDays: "Select your training days",
    days0: "0-days",
    days2: "2-days",
    days3: "3-days",
    days4: "4-days",
    days5: "5-days",
    days6: "6-days",
  },
  EquipmentCard: {
    chooseCardio: "Choose Available Cardio Equipments",
    undo: "Undo",
    cardio: "Cardio",
    select: "Select",
  },
  BodyFatQuestion: {
    title: "Select your body fat measurement method",
    inBody: "In-Body",
    anotherDevice: "Another Device",
    img: "Show Me Reference Image",
    percentage: "Enter your body fat percentage",
    subTitle: `Please approximate your body fat percentage based on the
        reference image.`,
    upload: "Kindly Upload Your In-Body",
    uploadTitle: "Upload In-Body image",
  },
  foodItem: {
    title: "Exclude Food You Dont like",
    subtitle:
      "Since you’re lactose intolerant, we’ve automatically excluded dairy items for you. Feel free to adjust this selection if needed.",
    categories: {
      protein: "Protein Source",
      carbs: "Carbs Source",
      fats: "Fats Source",
      fruits: "Fruit Source",
      salad: "Salad Source",
    },
  },
  genderInfo: {
    age: "Age",
    weight: "Weight",
    height: "Height",
    gender: "Gender",
    workoutTime: "Workout Time",
    male: "Male",
    female: "Female",
    upload: "Kindly Upload Your Body Photo",
    uploadTitle: "Upload Your Body Photo",
  },
  Injuries: {
    injury: "Write down your injury if you have",
    injuriesQuestion: {
      title: "Do you have any injuries ?",
      yes: "Yes",
      no: "No",
    },
    exeCant: "Write down exercises you can't do",
    injuriesFileUpload: {
      title: "Kindly upload your injury diagnose",
    },
  },
  mealsPerDay: {
    title: "Number of meals per day",
    meals2: "2 Meals + Snacks",
    meal: "How Do You Want Your Meals ?",
    meals3: "3 Meals + Snacks",
    meals4: "4 Meals + Snacks",
    lunch: "Breakfast, Lunch",
    dinner: "Lunch, Dinner",
    lactose: "You have issue with milk ?",
    yesLactose: "yes",
    noLactose: "no",
    nutritionDiseases: {
      question: "Do you suffer from any nutrition diseases ?",
      diseasesDescription: "Write down your disease",
      answers: {
        yes: "Yes",
        no: "No",
      },
    },
  },
  nutritionPlanGoal: {
    title: "Select your plan goal",
    extreme: "Extreme Fat Loss",
    fatLoss: "Fat Loss",
    reComposition: "Re-Composition",
    cleanBulking: "Clean Bulking",
    bulking: "Bulking",
    determine: "Determine For Me",
    description: "Describe your goal in more detail",
    toolTips: {
      extFatLoss: "I want to lose a lot of weight in the shortest time",
      fatLoss:
        "I want to lose fat at a normal and healthy rate and try to minimize muscle loss",
      reComposition:
        "I want my weight to be relatively stable, try to lose a little fat and maintain or increase muscle mass",
      cleanBulking:
        "I want to gain a bit of weight, mostly muscle, with minimal fat gain",
      bulking:
        "I want to significantly increase my weight, focusing on muscle gain and not minding the accompanying fat gain",
      determineForMe:
        "I'm not sure about my goal (The goal will be determined through the coach's assessment)",
    },
  },
  planPackage: {
    title: "Choose Your Plan Package",
  },
  supplementsQuestion: {
    protein: "Do you have whey protein ?",
    yesProtein: "Yes",
    noProtein: "No",
    mass: "Do you have mass gainer supplements?",
    yesMass: "Yes",
    noMass: "No",
    upload: "Kindly Upload Your Mass Gainer Nutrition Facts",
    chooseSupplement: "Choose Supplements You Have",
    choose: "Choose Supplements",
    dontSeeSupplement: "Don't see supplement you have ?",
    note: "Supplement Note",
  },
  WeakestMuscleGroups: {
    title: "Choose Your Weakest Muscle Groups",
    chest: "Chest",
    back: "Back",
    legs: "Legs",
    abs: "ABS",
    biceps: "Biceps",
    triceps: "Triceps",
    shoulders: "Shoulders",
    calves: "Calves",
    iDontKnow: "Let the coach decide for me",
  },
  workoutInitialQuestions: {
    train: "Where You Want To Train ?",
    gym: "Gym",
    home: "Home",
    equipment: "Choose your home equipment",
    workout: "Workout Frequency Per Week",
    day2: "2-Days",
    day3: "3-Days",
    day4: "4-Days",
    day5: "5-Days",
    day6: "6-Days",
    coach: "Let the coach decide",
  },
  workoutProgramGoal: {
    goal: "What's Your Workout Goal ?",
    building: "Muscle Building",
    strength: "Muscle Strength",
    endurance: "Muscle Endurance",
    shredding: "Shredding",
    dontKnowGoal: "I Don't Know My Goal",
    train: "How Long Have You Been Training ?",
    month0: "I never trained before",
    month16: "Begineer ( i have alittle experience training at the gym )",
    month612: "Intermediate",
    month12: "Advanced",
  },
  generalComments: {
    title: "Write down any comments you have ",
    textFieldLabel: "Comments",
  },
};

export default formComponentTranslations;
